import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/opt/app/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/opt/app/node_modules/@tanstack/react-query/build/modern/isRestoring.js");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/opt/app/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/opt/app/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/opt/app/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/opt/app/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/opt/app/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/opt/app/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/opt/app/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/opt/app/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/opt/app/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/opt/app/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/next-i18n-router/dist/client/useCurrentLocale.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThankYou"] */ "/opt/app/src/modules/thank-you/components/thank-you/thank-you.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EdgeConfigProvider","ConfigContext"] */ "/opt/app/src/shared/modules/edge-config/components/edge-config-provider/edge-config-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RuntimeEnvVariablesContext","RuntimeEnvVariablesProvider"] */ "/opt/app/src/shared/modules/environment/components/runtime-env-variables-provider/runtime-env-variables-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppQueryClientProvider"] */ "/opt/app/src/shared/modules/swr/components/app-query-client-provider/app-query-client-provider.tsx");
